import { FunctionComponent } from "react";

import "./table-menu-section.scss";
import { IProps } from "./table-menu-section.types";

/**
 * A section in a table's menu (only really used to apply styling).
 * @param props.children Section content.
 * @returns              Wrapped content.
 */
const TableMenuSection: FunctionComponent<IProps> = ({ children }) => {
    return <div className="grid__menu-section">{children}</div>;
};

export default TableMenuSection;
